import { QuickFilter } from '@zet/utils/Constants'

const resetQuickFilters = () => {
  QuickFilter['stage'].value = []
  QuickFilter['brands'].value = []
  QuickFilter['profileStatus'].value = []
  QuickFilter['category'].value = []
  return
}

export { resetQuickFilters }
